import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { setCreatePurchaseInvoice } from '../services/setCreatePurchaseInvoice';


export const createPurchaseInvoice = createAsyncThunk(
  'invoices/createPurchaseInvoice',
  async (params, { getState, dispatch }) => {
    console.log('params', params);
    const { purchaseInvoice } = params;

    const selectedProjectId = selectSelectedProjectId(getState());

    const response = await setCreatePurchaseInvoice(selectedProjectId, purchaseInvoice);
    console.log('response', response);
    return response;
  }
);
